export const uploadIcon=`<?xml version="1.0" encoding="utf-8"?>
<!— Generator: Adobe Illustrator 20.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  —>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve">
<style type="text/css">
  .st0{opacity:0;clip-path:url(#SVGID_2_);}
  .st1{clip-path:url(#SVGID_2_);fill:none;stroke:#aaa;stroke-width:2;stroke-miterlimit:10;}
  .st2{clip-path:url(#SVGID_2_);fill:none;stroke:#aaa;stroke-width:2;stroke-linecap:square;stroke-miterlimit:10;}
  .st3{opacity:0;clip-path:url(#SVGID_4_);}
  .st4{clip-path:url(#SVGID_4_);fill:none;stroke:#aaa;stroke-width:3;stroke-miterlimit:10;}
  .st5{clip-path:url(#SVGID_4_);fill:none;stroke:#aaa;stroke-width:3;stroke-linecap:square;stroke-miterlimit:10;}
</style>
<g>
  <defs>
    <rect id="SVGID_1_" x="-90.8" y="-1.1" width="58" height="58"/>
  </defs>
  <clipPath id="SVGID_2_">
    <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
  </clipPath>
  <line class="st0" x1="-61.8" y1="53.3" x2="-61.8" y2="24.3"/>
  <line class="st1" x1="-61.8" y1="53.3" x2="-61.8" y2="24.3"/>
  <polyline class="st0" points="-70.8,33.3 -61.8,24.3 -52.7,33.3   "/>
  <polyline class="st2" points="-70.8,33.3 -61.8,24.3 -52.7,33.3   "/>
  <path class="st0" d="M-54.5,40.6h10.9c5.1-0.5,9.1-4.7,9.1-10s-4-9.4-9.1-10c-0.9-9.1-8.7-16.3-18.1-16.3c-8.2,0-15,5.4-17.4,12.9
    c-5.4,0.9-9.8,5.8-9.8,11.6c0,6.2,4.7,11.2,10.9,11.8h9.1"/>
  <path class="st2" d="M-54.5,40.6h10.9c5.1-0.5,9.1-4.7,9.1-10s-4-9.4-9.1-10c-0.9-9.1-8.7-16.3-18.1-16.3c-8.2,0-15,5.4-17.4,12.9
    c-5.4,0.9-9.8,5.8-9.8,11.6c0,6.2,4.7,11.2,10.9,11.8h9.1"/>
</g>
<g>
  <defs>
    <rect id="SVGID_3_" x="2" y="1.9" width="60.1" height="60.1"/>
  </defs>
  <clipPath id="SVGID_4_">
    <use xlink:href="#SVGID_3_"  style="overflow:visible;"/>
  </clipPath>
  <line class="st3" x1="32.1" y1="31.9" x2="32.1" y2="5.6"/>
  <line class="st4" x1="32.1" y1="31.9" x2="32.1" y2="5.6"/>
  <polyline class="st3" points="22.7,15 32.1,5.6 41.4,15   "/>
  <polyline class="st5" points="22.7,15 32.1,5.6 41.4,15   "/>
  <polyline class="st3" points="49,9.4 58.4,9.4 58.4,45.1 5.8,45.1 5.8,9.4 15.1,9.4   "/>
  <polyline class="st5" points="49,9.4 58.4,9.4 58.4,45.1 5.8,45.1 5.8,9.4 15.1,9.4   "/>
  <line class="st3" x1="22.7" y1="58.2" x2="41.4" y2="58.2"/>
  <line class="st5" x1="22.7" y1="58.2" x2="41.4" y2="58.2"/>
  <line class="st3" x1="32.1" y1="52.6" x2="32.1" y2="58.2"/>
  <line class="st5" x1="32.1" y1="52.6" x2="32.1" y2="58.2"/>
</g>
</svg>`;
